/**
*
*   Accordion
*       - Accordion Dropdown
*
**/
'use client';
import Config from '@/config';
import Accordion from '@/components/safety/accordion';
import { useTranslations } from 'next-intl';
import { Fragment } from 'react';


//Build the Collection
export default function SafetyAccordion({ children , option , ...props }){

	//Get the Messages
	const t = useTranslations();

	//The Chart Data
	const Chart = {
		caption: [
			{
				value: 1,
				text: t('Pages.Safety.captions.safe')
			},{
				value: 2,
				text: t('Pages.Safety.captions.monitor')
			},{
				value: 3,
				text: t('Pages.Safety.captions.sparing')
			}
		],
		list: [
			{
				title:      t('Navigation.essential-oils'),
				categories: [{
						title:  t('Pages.Safety.categories.2+.title'),
						info:   t('Pages.Safety.categories.2+.info'),
						size:   15
					},{
						title:  t('Pages.Safety.categories.6-12.title'),
						info:   t('Pages.Safety.categories.6-12.info'),
						size:   15
					},{
						title:  t('Pages.Safety.categories.dog.title'),
						info:   t('Pages.Safety.categories.dog.info'),
						size:   15
					},{
						title:  t('Pages.Safety.categories.cat.title'),
						info:   t('Pages.Safety.categories.cat.info'),
						size:   15
					},{
						title:  t('Pages.Safety.categories.pregnancy.title'),
						info:   t('Pages.Safety.categories.pregnancy.info'),
						size:   20
					}],
				options:        [{
						name:       'Bergamot',
						options:    [1,1,1,3,1]
					},{
						name:       'Black Pepper',
						handle:     'black-pepper',
						options:    [1,1,1,2,1]
					},{
						name:       'Cajeput',
						options:    [3,2,3,3,3]
					},{
						name:       'Cedarwood',
						options:    [1,1,1,1,1]
					},{
						name:       'Cinnamon',
						options:    [2,1,3,3,3]
					},{
						name:       'Citronella',
						options:    [2,1,1,3,1]
					},{
						name:       'Chamomile',
						options:    [1,1,1,1,1]
					},{
						name:       'Clary Sage',
						handle:     'clary-sage',
						options:    [1,1,1,1,3]
					},{
						name:       'Clove',
						options:    [3,2,3,3,3]
					},{
						name:       'Cypress',
						options:    [1,1,1,3,1]
					},{
						name:       'Eucalyptus',
						options:    [3,3,3,3,3]
					},{
						name:       'Fir Needle',
						handle:     'fir-needle',
						options:    [1,1,1,3,1]
					},{
						name:       'Frankincense',
						options:    [1,1,1,1,2]
					},{
						name:       'Geranium',
						options:    [1,1,1,3,1]
					},{
						name:       'Ginger',
						options:    [1,1,1,2,1]
					},{
						name:       'Grapefruit',
						options:    [1,1,1,3,1]
					},{
						name:       'Juniper Berry',
						handle:     'juniper-berry',
						options:    [1,1,1,3,1]
					},{
						name:       'Lavender',
						options:    [1,1,1,2,1]
					},{
						name:       'Lemon',
						options:    [1,1,1,3,1]
					},{
						name:       'Lemongrass',
						options:    [2,1,2,3,2]
					},{
						name:       'Lime',
						options:    [2,1,1,3,1]
					},{
						name:       'Mandarin',
						options:    [1,1,1,3,1]
					},{
						name:       'Marjoram',
						options:    [1,1,2,3,1]
					},{
						name:       'Neroli',
						options:    [1,1,1,3,1]
					},{
						name:       'Nutmeg',
						options:    [3,3,3,3,3]
					},{
						name:       'Orange',
						options:    [1,1,1,3,1]
					},{
						name:       'Oregano',
						options:    [3,3,3,3,3]
					},{
						name:       'Patchouli',
						options:    [1,1,2,2,1]
					},{
						name:       'Peppermint',
						options:    [3,2,3,3,1]
					},{
						name:       'Petitgrain',
						options:    [2,1,3,2,1]
					},{
						name:       'Pine',
						options:    [3,2,3,3,3]
					},{
						name:       'Rose',
						options:    [2,1,2,3,1]
					},{
						name:       'Rosemary',
						options:    [3,3,1,3,3]
					},{
						name:       'Sandalwood',
						options:    [2,1,2,3,1]
					},{
						name:       'Spearmint',
						options:    [2,1,3,3,1]
					},{
						name:       'Spruce',
						options:    [3,2,2,3,3]
					},{
						name:       'Tangerine',
						options:    [2,1,3,3,1]
					},{
						name:       'Tea Tree',
						handle:     'tea-tree',
						options:    [2,1,3,3,1]
					},{
						name:       'Thyme',
						options:    [2,1,3,3,3]
					},{
						name:       'Vanilla',
						options:    [2,1,2,2,1]
					},{
						name:       'Vetiver',
						options:    [1,1,2,3,2]
					},{
						name:       'Wintergreen',
						options:    [3,3,3,3,3]
					},{
						name:       'Ylang Ylang',
						handle:     'ylang-ylang',
						options:    [2,1,3,3,1]
					}]
			},
			{
				title:      t('Navigation.essential-oil-blends'),
				categories: [{
						title:  t('Pages.Safety.categories.2+.title'),
						info:   t('Pages.Safety.categories.2+.info'),
						size:   15
					},{
						title:  t('Pages.Safety.categories.6-12.title'),
						info:   t('Pages.Safety.categories.6-12.info'),
						size:   15
					},{
						title:  t('Pages.Safety.categories.dog.title'),
						info:   t('Pages.Safety.categories.dog.info'),
						size:   15
					},{
						title:  t('Pages.Safety.categories.cat.title'),
						info:   t('Pages.Safety.categories.cat.info'),
						size:   15
					},{
						title:  t('Pages.Safety.categories.pregnancy.title'),
						info:   t('Pages.Safety.categories.pregnancy.info'),
						size:   20
					}],
				options:        [{
						name:       'Aurora',
						options:    [1,1,2,3,1]
					},{
						name:       'Cascade',
						options:    [1,1,2,3,1]
					},{
						name:       'Boreal',
						options:    [3,2,3,3,3]
					},{
						name:       'Breathe',
						options:    [3,3,3,3,3]
					},{
						name:       'Coast',
						options:    [1,1,1,3,1]
					},{
						name:       'Dream',
						options:    [1,1,1,3,2]
					},{
						name:       'Dawn',
						options:    [2,2,3,3,2]
					},{
						name:       'Cove',
						options:    [1,1,2,3,2]
					},{
						name:       'Harmony',
						options:    [1,1,1,3,2]
					},{
						name:       'Meadow',
						options:    [1,1,2,3,2]
					},{
						name:       'River',
						options:    [1,1,2,3,1]
					},{
						name:       'Soothe',
						options:    [3,1,3,3,2]
					},{
						name:       'Willow',
						options:    [1,1,2,3,1]
					},{
						name:       'Spirit',
						options:    [3,3,3,3,2]
					}]
			},
			{
				title:      t('Navigation.sprays-and-mists'),
				categories: [{
						title:  t('Pages.Safety.categories.2+.title'),
						info:   t('Pages.Safety.categories.2+.info'),
						size:   15
					},{
						title:  t('Pages.Safety.categories.6-12.title'),
						info:   t('Pages.Safety.categories.6-12.info'),
						size:   15
					},{
						title:  t('Pages.Safety.categories.dog.title'),
						info:   t('Pages.Safety.categories.dog.info'),
						size:   15
					},{
						title:  t('Pages.Safety.categories.cat.title'),
						info:   t('Pages.Safety.categories.cat.info'),
						size:   15
					},{
						title:  t('Pages.Safety.categories.pregnancy.title'),
						info:   t('Pages.Safety.categories.pregnancy.info'),
						size:   20
					}],
				options:        [{
						name:       'Coast',
						handle:     'coast-spray',
						options:    [2,1,1,3,2]
					},{
						name:       'Doze',
						options:    [2,1,1,1,2]
					},{
						name:       'Goddess',
						options:    [2,1,2,2,2]
					},{
						name:       'Horizon',
						options:    [2,2,3,3,2]
					},{
						name:       'Mountain',
						options:    [2,2,3,3,2]
					},{
						name:       'Salt',
						options:    [2,1,1,1,1]
					},{
						name:       'Lavender',
						handle:     'lavender-spray',
						options:    [2,1,1,1,1]
					}]
			},
			{
				title:      t('Navigation.rollers'),
				categories: [{
						title:  t('Pages.Safety.categories.2+.title'),
						info:   t('Pages.Safety.categories.2+.info'),
						size:   26.66
					},{
						title:  t('Pages.Safety.categories.6-12.title'),
						info:   t('Pages.Safety.categories.6-12.info'),
						size:   26.66
					},{
						title:  t('Pages.Safety.categories.pregnancy.title'),
						info:   t('Pages.Safety.categories.pregnancy.info'),
						size:   26.66
					}],
				options:        [{
						name:       'Balance',
						options:    [3,2,3]
					},{
						name:       'Boost',
						options:    [3,2,3]
					},{
						name:       'Dream',
						options:    [2,1,3]
					},{
						name:       'Remedy',
						options:    [3,2,3]
					},{
						name:       'Soothe',
						options:    [3,3,3]
					}]
			},
			{
				title:      t('Navigation.home-and-bath'),
				categories: [{
						title:  t('Pages.Safety.categories.2+.title'),
						info:   t('Pages.Safety.categories.2+.info'),
						size:   26.66
					},{
						title:  t('Pages.Safety.categories.6-12.title'),
						info:   t('Pages.Safety.categories.6-12.info'),
						size:   26.66
					},{
						title:  t('Pages.Safety.categories.pregnancy.title'),
						info:   t('Pages.Safety.categories.pregnancy.info'),
						size:   26.66
					}],
				options:        [{
						name:       'Renew Salt Soak',
						handle:     'renew',
						options:    [3,2,1]
					},{
						name:       'Grove Salt Soak',
						handle:     'grove',
						options:    [3,2,1]
					},{
						name:       'Drift Salt Soak',
						handle:     'drift',
						options:    [2,1,1]
					},{
						name:       'Shore Salt Soak',
						handle:     'shore',
						options:    [2,2,1]
					},{
						name:       'Serene Tea Soak',
						handle:     'serene',
						options:    [2,2,1]
					},{
						name:       'Blossom Tea Soak',
						handle:     'blossom',
						options:    [2,2,1]
					},{
						name:       'Soul Tea Soak',
						handle:     'soul',
						options:    [2,1,1]
					},{
						name:       'Pure Milk Bath',
						handle:     'pure',
						options:    [1,1,1]
					},{
						name:       'Bare Milk Bath',
						handle:     'bare',
						options:    [1,1,1]
					}]
			}
		]
	};

	return (
		<section id="essential-oil-safety-guide" className="guide">
			<div className="container">
				<header className="content">
					<h2>
						<span>
							{ t.rich('Pages.Safety.guide.header.pretext', Config.i18n.html ) }
						</span>
						{ t.rich('Pages.Safety.guide.header.title', Config.i18n.html ) }
					</h2>

					<p>
						{ t.rich('Pages.Safety.guide.content', Config.i18n.html ) }
					</p>

					<p>
						{ t.rich('Pages.Safety.guide.content2', Config.i18n.html ) }
					</p>

					<p>
						{ t.rich('Pages.Safety.guide.content3', Config.i18n.html ) }
					</p>

					<p>
						{ t.rich('Pages.Safety.guide.content4', Config.i18n.html ) }
					</p>

					<p>
						{ t.rich('Pages.Safety.guide.content5', Config.i18n.html ) }
					</p>

					<p>
						{ t.rich('Pages.Safety.guide.content6', Config.i18n.html ) }
					</p>

				</header>

				<div className="caption">
					<ul>
						{ Chart.caption.map( ( row, i ) => (
							<li key={ i }>
								<i>
									<span>{ row.value }</span>
								</i>
								{ row.text }
							</li>
						))}
						<li>
							<em>Hover (or click on mobile) info circles or the severity option for more information.</em>
						</li>
					</ul>
				</div>

				{ Chart.list.map( ( group , i ) => (
					<Fragment key={i}>

						{/* Mobile */}
						<div data-viewport="mobile">
							<h3>{ group.title }</h3>
							<ul>
								{ group.options.map( ( option , j ) => (
									<Accordion option={ option } key={j}>
										{ option.options.map( ( value , k ) => {
											const category  = Chart.list[i].categories[ k ];
											const info      = Chart.caption[ value - 1 ].text;
											return (
												<li key={ k }>
													<div>
														{ category.title }
														<span className="icon" onClick={ (e) => e.currentTarget.classList.toggle('open') }>
															<svg width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
																<path d="M6.8 3.5H8.2V4.9H6.8V3.5ZM6.8 6.3H8.2V10.5H6.8V6.3ZM7.5 0C3.636 0 0.5 3.136 0.5 7C0.5 10.864 3.636 14 7.5 14C11.364 14 14.5 10.864 14.5 7C14.5 3.136 11.364 0 7.5 0ZM7.5 12.6C4.413 12.6 1.9 10.087 1.9 7C1.9 3.913 4.413 1.4 7.5 1.4C10.587 1.4 13.1 3.913 13.1 7C13.1 10.087 10.587 12.6 7.5 12.6Z" fill="currentcolor"/>
															</svg>
															<div className="dialog">
																<div className="box">
																	<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
																		<path d="M17.7797 16.8012C17.8477 16.8646 17.9022 16.941 17.9401 17.0259C17.9779 17.1108 17.9983 17.2025 17.9999 17.2955C18.0015 17.3884 17.9844 17.4808 17.9496 17.567C17.9148 17.6532 17.863 17.7315 17.7972 17.7972C17.7315 17.863 17.6532 17.9148 17.567 17.9496C17.4808 17.9844 17.3884 18.0015 17.2955 17.9999C17.2025 17.9983 17.1108 17.9779 17.0259 17.9401C16.941 17.9022 16.8646 17.8477 16.8012 17.7797L8.98273 9.96235L1.16427 17.7797C1.03303 17.9019 0.85945 17.9685 0.680095 17.9654C0.50074 17.9622 0.329615 17.8895 0.202772 17.7627C0.0759294 17.6358 0.00327237 17.4647 0.000107859 17.2854C-0.00305665 17.106 0.0635184 16.9324 0.185808 16.8012L8.00312 8.98273L0.185808 1.16427C0.0635184 1.03303 -0.00305665 0.85945 0.000107859 0.680095C0.00327237 0.50074 0.0759294 0.329615 0.202772 0.202772C0.329615 0.0759294 0.50074 0.00327237 0.680095 0.000107859C0.85945 -0.00305665 1.03303 0.0635184 1.16427 0.185808L8.98273 8.00312L16.8012 0.185808C16.9324 0.0635184 17.106 -0.00305665 17.2854 0.000107859C17.4647 0.00327237 17.6358 0.0759294 17.7627 0.202772C17.8895 0.329615 17.9622 0.50074 17.9654 0.680095C17.9685 0.85945 17.9019 1.03303 17.7797 1.16427L9.96235 8.98273L17.7797 16.8012Z" fill="currentcolor"/>
																	</svg>
																	<p>
																		{ category.info }
																	</p>
																</div>
															</div>
														</span>
													</div>
													<div>
														<div className="icon" onClick={ (e) => e.currentTarget.classList.toggle('open') }>
															<i>
																<span>{ value }</span>
															</i>
															<div className="dialog">
																<div className="box">
																	<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
																		<path d="M17.7797 16.8012C17.8477 16.8646 17.9022 16.941 17.9401 17.0259C17.9779 17.1108 17.9983 17.2025 17.9999 17.2955C18.0015 17.3884 17.9844 17.4808 17.9496 17.567C17.9148 17.6532 17.863 17.7315 17.7972 17.7972C17.7315 17.863 17.6532 17.9148 17.567 17.9496C17.4808 17.9844 17.3884 18.0015 17.2955 17.9999C17.2025 17.9983 17.1108 17.9779 17.0259 17.9401C16.941 17.9022 16.8646 17.8477 16.8012 17.7797L8.98273 9.96235L1.16427 17.7797C1.03303 17.9019 0.85945 17.9685 0.680095 17.9654C0.50074 17.9622 0.329615 17.8895 0.202772 17.7627C0.0759294 17.6358 0.00327237 17.4647 0.000107859 17.2854C-0.00305665 17.106 0.0635184 16.9324 0.185808 16.8012L8.00312 8.98273L0.185808 1.16427C0.0635184 1.03303 -0.00305665 0.85945 0.000107859 0.680095C0.00327237 0.50074 0.0759294 0.329615 0.202772 0.202772C0.329615 0.0759294 0.50074 0.00327237 0.680095 0.000107859C0.85945 -0.00305665 1.03303 0.0635184 1.16427 0.185808L8.98273 8.00312L16.8012 0.185808C16.9324 0.0635184 17.106 -0.00305665 17.2854 0.000107859C17.4647 0.00327237 17.6358 0.0759294 17.7627 0.202772C17.8895 0.329615 17.9622 0.50074 17.9654 0.680095C17.9685 0.85945 17.9019 1.03303 17.7797 1.16427L9.96235 8.98273L17.7797 16.8012Z" fill="currentcolor"/>
																	</svg>
																	<p>
																		{ info }
																	</p>
																</div>
															</div>
														</div>
													</div>
												</li>
											);
										})}
									</Accordion>
								))}
							</ul>
						</div>

						{/* Desktop */}
						<table cellPadding="0" cellSpacing="0" data-viewport="desktop">
							<thead>
								<tr>
									<th width="20%">
										<div>
											{ group.title }
										</div>
									</th>
									{ group.categories.map( ( category, i ) => (
										<th key={i} width="{ category.size }%">
											<div>
												{ category.title }
												{ category?.info && (
													<span className="icon">
														<svg width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
															<path d="M6.8 3.5H8.2V4.9H6.8V3.5ZM6.8 6.3H8.2V10.5H6.8V6.3ZM7.5 0C3.636 0 0.5 3.136 0.5 7C0.5 10.864 3.636 14 7.5 14C11.364 14 14.5 10.864 14.5 7C14.5 3.136 11.364 0 7.5 0ZM7.5 12.6C4.413 12.6 1.9 10.087 1.9 7C1.9 3.913 4.413 1.4 7.5 1.4C10.587 1.4 13.1 3.913 13.1 7C13.1 10.087 10.587 12.6 7.5 12.6Z" fill="currentcolor"/>
														</svg>
														<div className="box">
															{ category.info }
														</div>
													</span>
												)}
											</div>
										</th>
									))}
								</tr>
							</thead>
							<tbody>
								{ group.options.map( ( option, i ) => (
									<tr key={i}>
										<td>
											<a href={ `/products/${   option.handle || option.name.toLowerCase().replace(/\s+/g,'-') }` } target="_blank">
												{ option.name }
											</a>
										</td>
										{ option.options.map( ( value, k ) => {
											const info = Chart.caption[ value - 1 ].text;
											return (
												<td key={k}>
													<div className="icon">
														<i>
															<span>{ value }</span>
														</i>
														<div className="box">
															{ info }
														</div>
													</div>
												</td>
											);
										})}
									</tr>
								))}
							</tbody>
						</table>
					</Fragment>
				))}
			</div>
		</section>
	);

}